import { useLazyQuery, useSubscription } from '@apollo/client/react'
import { useMemo } from 'react'
import {
  ActiveShiftUpdatedDocument,
  GetTableShiftDocument,
} from 'src/apollo/generated/graphql'

export const useSubscriptionActiveShiftsPage = () => {
  const [fetchTableShift] = useLazyQuery(GetTableShiftDocument, {
    fetchPolicy: 'network-only',
  })

  const timezone = useMemo(
    () => Intl.DateTimeFormat().resolvedOptions().timeZone,
    [],
  )

  useSubscription(ActiveShiftUpdatedDocument, {
    variables: { timezone },
    onData: ({ data: { data } }) => {
      if (!data?.activeShiftUpdated) return

      const id = data.activeShiftUpdated.id

      fetchTableShift({ variables: { getShiftInput2: { id: id } } })
    },
  })

  return {}
}
